<template>
  <div>
    <div class="row">
      <div class="col-lg-12" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">Programming Skills</h3>
          </template>
          <div class="chart-area">
            <bar-chart
              style="height: 100%"
              chart-id="blue-bar-chart"
              :chart-data="ProgrammingChart.chartData"
              :gradient-stops="ProgrammingChart.gradientStops"
              :extra-options="ProgrammingChart.extraOptions"
            ></bar-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">Front-end Frameworks</h3>
          </template>
          <div class="chart-area">
            <bar-chart
              style="height: 100%"
              chart-id="blue-bar-chart"
              :chart-data="FrontEndChart.chartData"
              :gradient-stops="FrontEndChart.gradientStops"
              :extra-options="FrontEndChart.extraOptions"
            ></bar-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">Back-end Frameworks</h3>
          </template>
          <div class="chart-area">
            <bar-chart
              style="height: 100%"
              chart-id="blue-bar-chart"
              :chart-data="BackEndChart.chartData"
              :gradient-stops="BackEndChart.gradientStops"
              :extra-options="BackEndChart.extraOptions"
            ></bar-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h3 class="card-title">Languages</h3>
          </template>
          <div class="chart-area">
            <bar-chart
              style="height: 100%"
              chart-id="blue-bar-chart"
              :chart-data="LanguageChart.chartData"
              :gradient-stops="LanguageChart.gradientStops"
              :extra-options="LanguageChart.extraOptions"
            ></bar-chart>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import TaskList from "./Dashboard/TaskList";
import UserTable from "./Dashboard/UserTable";
import config from "@/config";

export default {
  components: {
    LineChart,
    BarChart,
    TaskList,
    UserTable,
  },
  data() {
    return {
      ProgrammingChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ["C#", "Javascript", "SQL", "C", "Java"],
          datasets: [
            {
              label: "Code languages",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [90, 90, 80, 80, 60],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      LanguageChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ["English", "Spanish"],
          datasets: [
            {
              label: "Languages",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      FrontEndChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ["Vue.js", "React.js", "Angular"],
          datasets: [
            {
              label: "Front-end",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [90, 50, 70],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      BackEndChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ["Node.js", ".Net", "express"],
          datasets: [
            {
              label: "Back-end",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [90, 90, 70],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
    };
  },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    bigLineChartCategories() {
      return this.$t("dashboard.chartCategories");
    },
  },
  methods: {},
  mounted() {
    // this.i18n = this.$i18n;
    // if (this.enableRTL) {
    //   this.i18n.locale = 'ar';
    //   this.$rtl.enableRTL();
    // }
  },
  beforeDestroy() {
    // if (this.$rtl.isRTL) {
    //   this.i18n.locale = 'en';
    //   this.$rtl.disableRTL();
    // }
  },
};
</script>
<style>
</style>
